import { defineAsyncComponent, defineComponent } from 'vue';
import Modules from '@app/modules';
import Store from '@app/store';
import { locale } from '@app/global/helpers';
import { useModal } from '@app/composables/useModal';
export default defineComponent({
    components: {
        AppHeader: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-AppComponents" */ '@app/components/Header.vue')),
        AppBar: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-AppComponents" */ '@app/components/AppBar.vue')),
        AppFooter: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-AppComponents" */ '@app/components/Footer.vue')),
        AppCookieConsent: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-AppComponents" */ '@app/components/CookieConsent.vue')),
        UiModal: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-AppComponents" */ '@app/components/UI/Modal.vue')),
    },
    setup() {
        Store.ACTIONS.loadRoutesData();
        Store.MUTATIONS.setLocale(locale());
        const { activeModal, closeModal } = useModal();
        return {
            activeModal,
            closeModal,
            showCookieConsent: window.COOKIE_CONSENT,
            appModuleComponents: Modules.getTaggedComponents('app'),
        };
    },
});
